import useAuthStore from '@pkg/auth/useStore';

const useCanSwitchViewModes = () => {
  const me = useAuthStore((state) => state.me);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isRoleOnly = useAuthStore((state) => state.me?.is_role_only);

  const canViewSwitcher = isAuthenticated && !isRoleOnly;

  return canViewSwitcher;
};

export default useCanSwitchViewModes;
